import React from "react";
import Steps from "antd/lib/steps";
import vhCheck from "vh-check";
import { IMenuProps } from "../MenuProps";
import "../../styles";

import { Materials, Stones, Engraving, Dimensions } from "./Tabs/Tabs";

import {
  Checkout as CheckoutModal,
  ShortLink as ShortLinkModal,
  Summary as SummaryModal,
} from "./Modals/Modals";

import {
  SvgIcon,
  ButtonWithBackground,
  isMobile,
  isLowHeight,
} from "./ui-helpers";

import {
  MenuContainer,
  TotalPriceContainer,
  TotalPrice,
  FooterContainer,
  FooterMenuNavigation,
  MenuNavigationItem,
  Main,
  ControlItem,
  HeaderContainer,
  ContentContainer,
  HeaderContainerSegment,
  TotalPriceContainerMobile,
  FooterMenuNavigationSection,
} from "./MenuIFR-styled";
import {
  CloseCircleOutlined,
  InfoCircleOutlined,
  ShareAltOutlined,
  ShoppingOutlined,
} from "@ant-design/icons";

const { Step } = Steps;

interface State {
  deviceInfo: { vh?: number };
  scrolling: boolean;
}

export default class MenuIFR extends React.Component<IMenuProps, State> {
  private _scrollTimeout = null;

  constructor(props: IMenuProps) {
    super(props);
    this.state = {
      deviceInfo: {},
      scrolling: false,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize);
    this.resize();
  }

  resize = () => {
    if (!isMobile() && this.props.currentMenuTab === -1) {
      this.props.onMenuTabChange(0);
    } else {
      //We always want to call onMenuTabChange for its side effects
      this.props.onMenuTabChange(this.props.currentMenuTab);
    }
    this.setState({ deviceInfo: vhCheck() });
  };

  onTabSelect = (current: number) => {
    this.props.onMenuTabChange(current);
  };

  onTabSelectMobileVersion = (current: number) => {
    const currentMenuTab = current === this.props.currentMenuTab ? -1 : current;
    this.props.onMenuTabChange(currentMenuTab);
  };

  private _onScroll = () => {
    if (this.state.scrolling) return;

    this.setState(
      {
        scrolling: true,
      },
      () => {
        //console.log(this.state.scrolling);
        this._scrollTimeout = window.setTimeout(this._onScrollStop, 600);
      },
    );
  }; // /_onScroll()

  private _onScrollStop = () => {
    this.setState(
      {
        scrolling: false,
      },
      () => {
        //console.log(this.state.scrolling);
      },
    );
  }; // /_onScrollStop()

  render() {
    const { deviceInfo, scrolling } = this.state;

    const {
      currentMenuTab,
      checkoutModalVisible,
      checkoutURI,
      setCheckoutModalVisibility,
      shortLinkModalVisible,
      shortLink,
      setShortLinkModalVisibility,
      summaryModalVisible,
      setSummaryModalVisibility,

      ringSKU,
      ringScreenshot,
      configID,
      assetURI,

      checkoutIssues,
      price,

      fingerSize,
      fingerSizeFormatOptions,
      onFingerSizeChange,
      fingerSizeFormat,
      fingerSizeOptions,
      onFingerSizeFormatChange,
      ringWidth,
      ringWidthOptions,
      onRingWidthChange,
      ringThickness,
      ringThicknessOptions,
      onRingThicknessChange,
      autoRatio,
      onAutoRatioChange,

      metalGroups,
      onMetalGroupChange,
      currentMenuMetalGroup,
      onMenuMetalGroupChange,
      limitedMaterials,

      stoneCut,
      stoneCount,
      stoneCountOptions,
      onStoneCountChange,
      stoneSize,
      stoneSizeOptions,
      onStoneSizeChange,
      stoneGroups,
      onStoneGroupChange,
      currentMenuStoneGroup,
      onMenuStoneGroupChange,

      engravingText,
      onEngravingTextChange,
      engravingFont,
      engravingFontOptions,
      onEngravingFontChange,
    } = this.props;

    const tabs = [
      {
        title: "Dimensions",
        icon: "dimensions",
        content: (
          <Dimensions
            fingerSize={fingerSize}
            fingerSizeOptions={fingerSizeOptions}
            onFingerSizeChange={onFingerSizeChange}
            fingerSizeFormat={fingerSizeFormat}
            fingerSizeFormatOptions={fingerSizeFormatOptions}
            onFingerSizeFormatChange={onFingerSizeFormatChange}
            ringWidth={ringWidth}
            ringWidthOptions={ringWidthOptions}
            onRingWidthChange={onRingWidthChange}
            ringThickness={ringThickness}
            ringThicknessOptions={ringThicknessOptions}
            onRingThicknessChange={onRingThicknessChange}
            autoRatio={autoRatio}
            onAutoRatioChange={onAutoRatioChange}
            checkoutIssues={checkoutIssues}
            scrolling={scrolling}
            rings={this.props.rings}
            ringState={this.props.ringState}
            setShape={this.props.setShape}
			assetURI={assetURI}
          />
        ),
      },
      {
        title: "Materials",
        icon: "materials",
        content: (
          <Materials
            metalGroups={metalGroups}
            onMetalGroupChange={onMetalGroupChange}
            currentMenuMetalGroup={currentMenuMetalGroup}
            onCurrentMenuMetalGroupChange={onMenuMetalGroupChange}
            limitedMaterials={limitedMaterials}
            assetURI={assetURI}
          />
        ),
      },
      {
        title: "Stones",
        icon: "stones",
        content: (
          <Stones
            stoneCut={stoneCut}
            stoneCount={stoneCount}
            stoneCountOptions={stoneCountOptions}
            onStoneCountChange={onStoneCountChange}
            stoneSize={stoneSize}
            stoneSizeOptions={stoneSizeOptions}
            onStoneSizeChange={onStoneSizeChange}
            stoneGroups={stoneGroups}
            onStoneGroupChange={onStoneGroupChange}
            currentMenuStoneGroup={currentMenuStoneGroup}
            onCurrentMenuStoneGroupChange={onMenuStoneGroupChange}
            scrolling={scrolling}
            assetURI={assetURI}
          />
        ),
      },
      {
        title: "Engraving",
        icon: "engraving",
        content: (
          <Engraving
            engravingText={engravingText}
            onEngravingTextChange={onEngravingTextChange}
            engravingFont={engravingFont}
            engravingFontOptions={engravingFontOptions}
            onEngravingFontChange={onEngravingFontChange}
          />
        ),
      },
    ];

    const mobile = isMobile();
    const lowHeight = isLowHeight();

    return (
      <MenuContainer className="menu-ifr threed-configurator-menu-container">
        <Main
          className="threed-configurator-menu-main"
          show={currentMenuTab >= 0}
          deviceInfo={deviceInfo as any}
        >
          {mobile && (
            <HeaderContainer className="threed-configurator-menu-header-container">
              <HeaderContainerSegment className="threed-configurator-menu-header-segment">
                <span>$ {this.props.price.toLocaleString("en-US")}</span>
              </HeaderContainerSegment>

              <HeaderContainerSegment className="threed-configurator-menu-header-segment">
                {/* This element only exists to keep its siblings aligned correctly */}
              </HeaderContainerSegment>

              <HeaderContainerSegment className="threed-configurator-menu-header-segment">
                <ControlItem
                  className="threed-configurator-control-item"
                  style={{
                    backgroundColor: "transparent",
                    pointerEvents: "auto",
                    float: "right",
                  }}
                >
                  <CloseCircleOutlined
                    className="threed-configurator-icon"
                    type="close-circle"
                    onClick={() => this.onTabSelect(-1)}
                    style={{
                      backgroundColor: "white",
                      fontSize: "40px",
                      marginRight: "26px",
                      marginTop: "26px",
                      zIndex: 14,
                      borderRadius: "50%",
                    }}
                  />
                </ControlItem>
              </HeaderContainerSegment>
            </HeaderContainer>
          )}
          <ContentContainer
            className="threed-configurator-menu-content-container"
            onScroll={this._onScroll}
          >
            {" "}
            {/* Force rerender to update slider tooltips. FIXME: find more performant way to do this...? */}
            {currentMenuTab >= 0 && tabs[currentMenuTab].content}
          </ContentContainer>
        </Main>

        {mobile && currentMenuTab < 0 && (
          <TotalPriceContainerMobile className="threed-configurator-price-container-mobile">
            <div>
              <span>$ {this.props.price.toLocaleString("en-US")}</span>
            </div>
            <div>
              <InfoCircleOutlined
                className="threed-configurator-icon"
                type="info-circle"
                onClick={() => setSummaryModalVisibility(true)}
              />
            </div>
            <div>
              <ShareAltOutlined
                className="threed-configurator-icon"
                type="share-alt"
                onClick={this.props.onShareButtonClick}
              />
            </div>
            <div>
              <ShoppingOutlined
                className="threed-configurator-icon"
                type="shopping"
                onClick={this.props.onCheckout}
              />
            </div>
          </TotalPriceContainerMobile>
        )}

        <FooterContainer className="threed-configurator-menu-footer-container">
          <TotalPriceContainer className="threed-configurator-price-container">
            <TotalPrice className="threed-configurator-price">
              Total price
              <span>$ {this.props.price.toLocaleString("en-US")}</span>
            </TotalPrice>
            <ButtonWithBackground
              className="threed-configurator-menu-order-button"
              onClick={this.props.onCheckout}
            >
              Order Ring
            </ButtonWithBackground>
          </TotalPriceContainer>

          <FooterMenuNavigation className="threed-configurator-footer-menu-navigation">
            {!mobile && (
              <FooterMenuNavigationSection className="threed-configurator-footer-menu-navigation-section">
                {/* This element only exists to keep its siblings aligned correctly */}
              </FooterMenuNavigationSection>
            )}

            <FooterMenuNavigationSection className="threed-configurator-footer-menu-navigation-section">
              {tabs.map(({ title, icon }, index) => {
                if (title !== "Overview")
                  return (
                    <MenuNavigationItem
                      className="threed-configurator-menu-navigation-item"
                      key={index}
                      isActive={currentMenuTab === index}
                      onClick={() => {
                        if (mobile) {
                          this.onTabSelectMobileVersion(index);
                        } else {
                          this.onTabSelect(index);
                        }
                      }}
                    >
                      <SvgIcon
                        className="threed-configurator-svg-icon"
                        type={icon}
                        hoverColor="#000"
                      />
                      <div>{title}</div>
                    </MenuNavigationItem>
                  );
              })}
            </FooterMenuNavigationSection>

            {!mobile && (
              <FooterMenuNavigationSection className="threed-configurator-footer-menu-navigation-section">
                <MenuNavigationItem
                  className="threed-configurator-menu-navigation-item"
                  isActive={false}
                  onClick={() => setSummaryModalVisibility(true)}
                >
                  <InfoCircleOutlined
                    className="threed-configurator-icon"
                    type="info-circle"
                  />
                  <div style={{ fontSize: "12px" }}>Info</div>
                </MenuNavigationItem>
                <MenuNavigationItem
                  className="threed-configurator-menu-navigation-item"
                  isActive={false}
                  onClick={this.props.onShareButtonClick}
                >
                  <ShareAltOutlined
                    className="threed-configurator-icon"
                    type="share-alt"
                  />
                  <div style={{ fontSize: "12px" }}>Share</div>
                </MenuNavigationItem>
              </FooterMenuNavigationSection>
            )}
          </FooterMenuNavigation>
        </FooterContainer>

        <CheckoutModal
          checkoutModalVisible={checkoutModalVisible}
          checkoutURI={checkoutURI}
          setCheckoutModalVisibility={setCheckoutModalVisibility}
        ></CheckoutModal>

        <ShortLinkModal
          shortLinkModalVisible={shortLinkModalVisible}
          shortLink={shortLink}
          setShortLinkModalVisibility={setShortLinkModalVisibility}
        ></ShortLinkModal>

        <SummaryModal
          summaryModalVisible={summaryModalVisible}
          setSummaryModalVisibility={setSummaryModalVisibility}
          isMobile={mobile}
          isLowHeight={lowHeight}
          configID={configID}
          assetURI={assetURI}
          ringSKU={ringSKU}
          ringScreenshot={ringScreenshot}
          fingerSize={fingerSize}
          ringWidth={ringWidth}
          ringThickness={ringThickness}
          price={price}
          metalGroups={metalGroups}
          stoneCut={stoneCut}
          stoneCount={stoneCount}
          stoneSize={stoneSize}
          stoneGroups={stoneGroups}
          engravingText={engravingText}
          engravingFont={engravingFont}
          limitedMaterials={limitedMaterials}
        ></SummaryModal>
      </MenuContainer>
    );
  }
}
